import * as React from 'react';
export const IcInfrastructure = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 13a1 1 0 100-2h-2.78v-.1l1.9-3.9A2 2 0 1019 3a2 2 0 00-1.72 1h-3.56a2 2 0 00-3.44 0H6.72A2 2 0 005 3a2 2 0 10-.12 4l2 3.91v.1H4a1 1 0 000 2h2.78v.1L4.88 17A2 2 0 105 21a2 2 0 001.72-1h3.56a2 2 0 003.44 0h3.56A2 2 0 0019 21a2.001 2.001 0 00.12-4l-1.95-3.9V13H20zm-8-5.76l1.83 3.66s0 .07-.05.1h-3.56s0-.07-.05-.1L12 7.24zM6.67 6.1V6h3.56s0 .07.05.1L8.5 9.76 6.67 6.1zM10.28 18H6.72v-.1l1.78-3.66 1.83 3.66s-.03.1-.05.1zM12 16.76l-1.83-3.66s0-.07.05-.1h3.56s0 .07.05.1L12 16.76zm5.33 1.14v.1h-3.61s0-.07-.05-.1l1.83-3.66 1.83 3.66zM15.5 9.76L13.67 6.1s0-.07.05-.1h3.56v.1L15.5 9.76z'
      fill='currentColor'
    />
  </svg>
);
